import * as types from '@store/types'
import axios from 'axios'

const actions = {
  [types.VIDALINK]: async ({ dispatch }, payload) => {
    try {
      const response = await axios.post('/vidalink/active', payload)
      if (response && response.data && response.data.success) {
        dispatch(types.FEEDBACK, {
          type: 'success',
          text: 'Seu cartão foi criado com sucesso'
        })
        return true
      } else {
        dispatch(types.FEEDBACK, {
          type: 'error',
          title: 'Houve um erro ao ativar o seu cartão',
          text: ''
        })
        return false
      }
    } catch (err) {
      dispatch(types.FEEDBACK, {
        type: 'error',
        title: 'Houve um erro ao ativar o seu cartão',
        text: ''
      })
      return false
    }
  }
}

export default { actions }



// WEBPACK FOOTER //
// ./src/store/modules/vidalink.js